import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChatReadReceipt = gql`
  mutation ChatReadReceipt(
    $idempotencyId: IdempotencyToken!
    $input: ChatReadReceiptInput!
  ) {
    chatReadReceipt(idempotencyId: $idempotencyId, input: $input) {
      __typename
      ... on ChatReadReceiptError {
        __typename
        ...error
      }
      ... on ChatReadReceiptSuccess {
        id
        createdAt
      }
    }
  }
  ${error}
`;

export default ChatReadReceipt;
